import { Link } from '@tanstack/react-router';
import { type FC, type PropsWithChildren } from 'react';

interface Props {
  href: string;
  label?: string;
  external?: boolean;
}

const FooterLink: FC<PropsWithChildren<Props>> = ({ href, label, external, children }) => {
  return external ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-white transition-colors"
      aria-label={label}
    >
      {children}
    </a>
  ) : (
    <Link to={href} className="text-gray-300 hover:text-white transition-colors">
      {children}
    </Link>
  );
};

export default FooterLink;
